import { EnvironmentBase, environmentBase } from './environment-base';

export const environment: EnvironmentBase = {
  ...environmentBase,
  production: true,
};
